var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStrike = function SvgStrike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4F8",
    d: "M10.313 8.313c.365 0 .687.322.687.687a.69.69 0 0 1-.687.688H.688A.68.68 0 0 1 0 9V.75C0 .385.3.063.688.063c.365 0 .687.322.687.687v7.563zM2.385 5.906c-.258-.258-.258-.687 0-.967l1.59-1.568a.663.663 0 0 1 .966 0l1.59 1.568 1.332-1.332-.88-.88c-.215-.215-.065-.602.236-.602h2.75a.37.37 0 0 1 .344.344v2.75c0 .3-.366.472-.602.258l-.88-.903L7.003 6.4a.67.67 0 0 1-.473.194.68.68 0 0 1-.494-.194L4.47 4.832 3.373 5.906a.69.69 0 0 1-.988 0"
  })));
};
export default SvgStrike;